import type { BrandProfitTableDataQuery } from "@src/__generated__/urql-graphql";
import { makeObservable } from "mobx";
import { BrandReportBaseModel } from "../../common/models";

type TBrand = NonNullable<
  BrandProfitTableDataQuery["brandRevenue"]
>["result"][0];

export class BrandProfitModel extends BrandReportBaseModel {
  gross_profit_for_date_range: TBrand["gross_profit_for_date_range"];
  expenses_profit_for_date_range: TBrand["expenses_profit_for_date_range"];
  our_work_revenue_for_date_range: TBrand["our_work_revenue_for_date_range"];
  total_profit_share: TBrand["total_profit_share"];
  filtered_profit_share: TBrand["filtered_profit_share"];
  __subRows: NonNullable<TBrand["brands"]> | undefined;

  constructor(src: TBrand) {
    super(src);
    makeObservable(this);
    this.our_work_revenue_for_date_range = src.our_work_revenue_for_date_range;
    this.gross_profit_for_date_range = src.gross_profit_for_date_range;
    this.expenses_profit_for_date_range = src.expenses_profit_for_date_range;
    this.filtered_profit_share = src.filtered_profit_share;
    this.total_profit_share = src.total_profit_share;
    this.our_work_revenue_for_date_range = src.our_work_revenue_for_date_range;
    this.__subRows = src.brands ?? undefined;
  }
}
